import { Provider } from '@angular/core';
import { ConfigurationDataHttpService } from './abstract';
import { ConfigurationDataHttpServiceImpl } from './configuration-data-http.service';

export const ConfigurationDataHttpProvider: Provider = {
	provide: ConfigurationDataHttpService,
	useClass: ConfigurationDataHttpServiceImpl,
};
